import { render, staticRenderFns } from "./specifiedHome.vue?vue&type=template&id=6f703d01&scoped=true&"
import script from "./specifiedHome.vue?vue&type=script&lang=js&"
export * from "./specifiedHome.vue?vue&type=script&lang=js&"
import style0 from "./specifiedHome.vue?vue&type=style&index=0&id=6f703d01&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f703d01",
  null
  
)

export default component.exports